import React from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { IconArrowLeft } from "@velaro/velaro-component-lib/";

export default function HubSpotOverview() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="font-semibold group flex items-center gap-2 justify-between mb-6">
        <div className="flex items-center gap-2">
          <div className="w-14 h-14 border-slate-300 relative mr-4 rounded border p-2 content-center flex items-center justify-center">
            <img src="/img/hubspot-crm.svg" alt="HubSpot" className="w-10 h-10" />
          </div>
          <div>
            <div className="font-semibold text-slate-gray-800 text-lg">HubSpot CRM</div>
            <div className="font-normal text-slate-gray-400 text-sm">
              Connect HubSpot to look up contacts, push transcripts, and sync chat data to your CRM.
            </div>
          </div>
        </div>
        <PrimaryBlueButton
          label="Connect HubSpot"
          onClick={() => navigate("/integrations/hubspot/create")}
          prefixIcon={null}
          className="font-medium"
        />
      </div>

      <div className="flex border-b mb-4">
        <div className="py-2 mr-4 cursor-pointer text-slate-800 text-sm border-b-2 border-b-slate-600 px-3">
          Overview
        </div>
      </div>

      <div className="text-sm text-slate-800 space-y-3">
        <p>
          Connect HubSpot CRM so your support agents can instantly look up contact history, deal status, and account details during live conversations — without switching tabs.
        </p>
        <p>
          When a chat ends, Velaro automatically pushes the full conversation transcript to HubSpot as a Note on the matched contact. Every interaction is logged, searchable, and available to your sales and support teams.
        </p>
        <p>
          You can also use HubSpot data in workflow nodes — query contacts, check lifecycle stage, or create new contacts automatically when a visitor provides their email.
        </p>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
        {[
          { title: "Contact Lookup", desc: "Search HubSpot contacts by email or name directly from the agent sidebar during live chats.", icon: "🔍" },
          { title: "Transcript Push", desc: "Full chat transcripts are automatically pushed to HubSpot as Notes on the matched contact after each conversation.", icon: "📝" },
          { title: "AI Workflow Tools", desc: "Workflow AI nodes can query HubSpot contacts, check lifecycle stage, and create contacts during automated flows.", icon: "🤖" }
        ].map((f) => (
          <div key={f.title} className="rounded-lg border border-slate-200 p-4">
            <div className="text-2xl mb-2">{f.icon}</div>
            <div className="font-medium text-slate-800 text-sm mb-1">{f.title}</div>
            <div className="text-xs text-slate-500">{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function HubSpotBackToIntegrationLanding() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations")}>
      <IconArrowLeft className="h-6 w-6" />
      Back
    </div>
  );
}

export function HubSpotBackToHubSpotOverview() {
  const navigate = useNavigate();
  return (
    <div className="flex cursor-pointer items-center gap-2 text-slate-600" onClick={() => navigate("/integrations/hubspot/overview")}>
      <IconArrowLeft className="h-6 w-6" />
      Back to HubSpot
    </div>
  );
}
